import React, { useEffect } from 'react';

// 1. REWARDED AD LOGIC
export const watchRewardedAd = (onComplete) => {
  // Check if the Google Ad Placement API is loaded
  if (window.adBreak) {
    window.adBreak({
      type: 'reward',
      name: 'get_stars',
      beforeAd: () => { console.log("Ad starting..."); },
      afterAd: () => { console.log("Ad finished."); },
      beforeReward: (showAdFn) => {
        // This is where the "Watch ad for 1000 stars?" prompt happens
        const confirmed = window.confirm("Watch a short ad for 1000 Stars?");
        if (confirmed) showAdFn();
      },
      adDismissed: () => { alert("Ad skipped - no stars earned."); },
      adViewed: () => { 
        // THIS IS THE IMPORTANT PART: Give the reward
        onComplete(); 
      },
    });
  } else {
    // FALLBACK for testing if ads aren't approved yet
    alert("AD SIMULATION: You watched a 5s ad.");
    setTimeout(() => {
      onComplete();
    }, 2000);
  }
};

// 2. BOTTOM BANNER COMPONENT
export const BottomBanner = ({ adClient, adSlot }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Adsbygoogle error:", e);
    }
  }, []);

  return (
    <div className="ad-banner-container" style={bannerStyle}>
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client={adClient}
           data-ad-slot={adSlot}
           data-ad-format="horizontal"
           data-full-width-responsive="true"></ins>
    </div>
  );
};

const bannerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '60px',
  background: '#0a0a0a',
  borderTop: '1px solid #333',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center'
};